import React, { Ref } from "react";
import * as PIXI from 'pixi.js'

import Loader from "./loader/loader";

import ButtonPanel from "./buttonpanel/buttonpanel"
import Autoplay from "./autoplay/autoplay"
import Basegame from "./basegame/basegame"
import Freegame from "./freegame/freegame"
import Bonus from "./bonus/bonus"
import Commongame from "./commongame/commongame"
import Layouts from "./layouts/layouts"

import { _ReactPixi, Container, Stage, Text, withPixiApp } from "@inlet/react-pixi";
import { actions as applicationActions } from '../reducers/applicationStateReducer'
import { connect, Provider } from "react-redux";
import { IStore } from "../store/IStore";
import { Dispatch } from "redux";

import Banner from "./banner/banner";
import Sounds from "./sounds/sounds";
import GAMESounds from "./../../components/sounds/sounds";
import PlayerMessage from "./playerMessage/playerMessage"
import UIManager from "./ui/UiBuilder";

import MenuInCanvas from "../../core/components/menu/menuInCanvas"
import AutoplayInCanvas from "../../core/components/autoplay/autoplayInCanvas"

import { isMobile } from "react-device-detect";
import Overlay from "../components/overlay/overlay"
import SymbolTray from "../../core/components/symbol/symbolTray";
import FlowManager from "../../core/components/flowManager/flowManager";
import { actions as asyncActions } from '../reducers/asyncInitAction'


interface IProps {
    app: PIXI.Application

    [x: string]: any;


}

interface IStateToProps {
    [x: string]: any;

}

interface IDispatchToProps {
    [x: string]: any;
}

interface IState {
    isGameLoaded: boolean,
    GameType: string,
    width: number | string,
    height: number | string,
    pixelRatio: number,
    resizing: boolean,
    lang: string
}


class MAINPAGE extends React.Component<IProps, IState> {

    protected app: PIXI.Application;

    // private alllanguage: Ilanguage;
    protected mainPageContainer: _ReactPixi.IContainer | Ref<any>;

    constructor(props: any) {
        super(props);
        this.app = props.app;
        // this.alllanguage = alllanguage;
        this.state = {
            width: this.props.width,
            height: this.props.height,
            pixelRatio: window.devicePixelRatio,
            isGameLoaded: false,
            resizing: false,
            GameType: "BASE",
            lang: this.props.langcode
        }
        this.mainPageContainer = React.createRef();

    }



    bindEvent() {

    }

    onLoadComplete = () => {
        this.props.setApplicationLoading(true);
        let loadingTimeout: any;
        loadingTimeout = setTimeout(() => {
            clearTimeout(loadingTimeout);
            this.props.setApplicationLoading(false);
        }, 100);
        this.setState((prevState) => {
            return {
                ...prevState,
                isGameLoaded: true,
            }
        })

    }


    updateDimensions = (arg: any) => {
        if (arg === "Resized") {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    width: window.outerWidth,
                    height: window.outerHeight,
                    pixelRatio: window.devicePixelRatio || 1
                }
            })
            // if (window.innerHeight > window.innerWidth) {
            //     this.props.setApplicationLayoutMode("Portrait");
            // } else {
            //     this.props.setApplicationLayoutMode("Landscape");
            // }
            this.calculateCanvas();
        }

    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        let resizeTimeout: any;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(this.updateDimensions, 100, "Resized");
        });
        //

        this.updateDimensions("Resized");
        resizeTimeout = setTimeout(
            () => {
                this.updateDimensions("Resized");

            }
            , 200)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    iniFrame() {
        if (window.location !== window.parent.location) {

            // The page is in an iFrames
            //  document.write("The page is in an iFrame");
            return true
        } else {

            // The page is not in an iFrame
            // document.write("The page is not in an iFrame");
            return false
        }
    }

    handleResizeChangeInIframe() {

        let
            width = 0,
            height = 0,
            scaleX = 0,
            scaleY = 0,
            scaleFactor = 0,
            viewWidth,
            viewHeight;
        let viewportWidth, viewportHeight: any, dpr;

        if (this.props.detectDevices.isAndroidMobile()) {
            if (window.devicePixelRatio > 2) {
                dpr = 1;// Math.min(window.devicePixelRatio, 2);
            } else {
                dpr = window.devicePixelRatio;
            }

        } else {
            dpr = window.devicePixelRatio;
        }

        // pixel ratios greater that 2 on some android devices mess up


        if (isMobile) {
            if (window.outerHeight > window.outerWidth) {
                this.props.setApplicationLayoutMode("Portrait");
                viewportWidth = this.props.constant.configGame.portraitCanvasWidth * dpr;
                viewportHeight = this.props.constant.configGame.portraitCanvasHeight * dpr;
            } else {
                this.props.setApplicationLayoutMode("Landscape");
                viewportWidth = this.props.constant.configGame.landscapeCanvasWidth * dpr;
                viewportHeight = this.props.constant.configGame.landscapeCanvasHeight * dpr;
            }
        } else {
            this.props.setApplicationLayoutMode("Landscape");
            viewportWidth = this.props.constant.configGame.canvasWidth;
            viewportHeight = this.props.constant.configGame.canvasHeight;

        }

        //isMobile
        if (this.props.detectDevices.isHandheld() === true && this.props.detectDevices.isSafariBrowser() === false) {
            if (this.props.detectDevices.isIOS9Mobile() === true) {
                viewWidth = window.outerWidth;
                viewHeight = window.outerHeight;
            } else {
                viewWidth = Math.min(document.documentElement.clientWidth, window.outerWidth || 0);
                viewHeight = Math.min(document.documentElement.clientHeight, window.outerHeight || 0);
            }
        } else {
            if (isMobile) {

                viewWidth = Math.min(document.documentElement.clientWidth, window.outerWidth || 0);
                viewHeight = Math.min(document.documentElement.clientHeight, window.outerHeight || 0);
            } else {
                viewWidth = window.innerWidth;
                viewHeight = window.innerHeight;
            }

        }
        // viewWidth = viewWidth / Math.min(window.devicePixelRatio);
        // viewWidth = viewWidth / Math.min(window.devicePixelRatio);

        scaleFactor = viewHeight / viewportHeight;
        if (Math.round(scaleFactor * viewportWidth) > viewWidth) {
            width = viewWidth;
            scaleX = viewWidth / viewportWidth;

            height = Math.ceil(scaleX * viewportHeight);
            scaleY = scaleX;
        } else {
            height = viewHeight;
            scaleY = viewHeight / viewportHeight;

            width = Math.ceil(scaleY * viewportWidth);
            scaleX = scaleY;
        }


        if (isMobile) {
            let Can_Width, Can_Height;
            if (window.innerHeight > window.innerWidth) {
                this.props.setApplicationLayoutMode("Portrait");
                Can_Width = this.props.constant.configGame.portraitCanvasWidth;
                Can_Height = this.props.constant.configGame.portraitCanvasHeight;
            } else {
                this.props.setApplicationLayoutMode("Landscape");
                Can_Width = this.props.constant.configGame.landscapeCanvasWidth;
                Can_Height = this.props.constant.configGame.landscapeCanvasHeight;
            }
            UIManager.getRef("mainPageOuterContainer").scale.x = (width * dpr) / Can_Width
            UIManager.getRef("mainPageOuterContainer").scale.y = (height * dpr) / Can_Height
            this.props.app.renderer.resize(viewportWidth / dpr * (width * dpr) / Can_Width, viewportHeight / dpr * (height * dpr) / Can_Height);
        }
        this.props.app.view.style.width = width + "px";
        this.props.app.view.style.height = height + "px";


        // this.props.app.resize();
        this.props.setApplicationResizeState(viewportWidth, viewportHeight, scaleX, scaleY);
        if (this.props.constant.configGame.centered === true) {
            this.props.app.view.style.position = "fixed";
            if (viewHeight > height) {
                this.props.app.view.style.top = (viewHeight / 2 - height / 2) + "px";
            } else {
                this.props.app.view.style.top = 0 + "px";
            }
            if (viewWidth > width) {
                this.props.app.view.style.left = (viewWidth / 2 - width / 2) + "px";
            } else {
                this.props.app.view.style.left = 0 + "px";
            }
        }
    }

    handleResizeChange() {


        let
            width = 0,
            height = 0,
            scaleX = 0,
            scaleY = 0,
            scaleFactor = 0,
            viewWidth,
            viewHeight;
        let viewportWidth, viewportHeight: any, dpr;

        if (this.props.detectDevices.isAndroidMobile()) {
            if (window.devicePixelRatio > 2) {
                dpr = 1;// Math.min(window.devicePixelRatio, 2);
            } else {
                dpr = window.devicePixelRatio;
            }

        } else {
            dpr = window.devicePixelRatio;
        }
        if (isMobile) {
            if (window.innerHeight > window.innerWidth) {
                this.props.setApplicationLayoutMode("Portrait");
                viewportWidth = this.props.constant.configGame.portraitCanvasWidth * dpr;
                viewportHeight = this.props.constant.configGame.portraitCanvasHeight * dpr;
            } else {
                this.props.setApplicationLayoutMode("Landscape");
                viewportWidth = this.props.constant.configGame.landscapeCanvasWidth * dpr;
                viewportHeight = this.props.constant.configGame.landscapeCanvasHeight * dpr;
            }
        } else {
            this.props.setApplicationLayoutMode("Landscape");
            viewportWidth = this.props.constant.configGame.canvasWidth;
            viewportHeight = this.props.constant.configGame.canvasHeight;

        }

        //isMobile
        if (this.props.detectDevices.isHandheld() === true && this.props.detectDevices.isSafariBrowser() === false) {
            if (this.props.detectDevices.isIOS9Mobile() === true) {
                viewWidth = window.innerWidth;
                viewHeight = window.innerHeight;
            } else {
                viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            }
        } else {
            if (isMobile) {

                viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            } else {
                viewWidth = window.innerWidth;
                viewHeight = window.innerHeight;
            }

        }
        scaleFactor = viewHeight / viewportHeight;
        if (Math.round(scaleFactor * viewportWidth) > viewWidth) {
            width = viewWidth;
            scaleX = viewWidth / viewportWidth;

            height = Math.ceil(scaleX * viewportHeight);
            scaleY = scaleX;
        } else {
            height = viewHeight;
            scaleY = viewHeight / viewportHeight;

            width = Math.ceil(scaleY * viewportWidth);
            scaleX = scaleY;
        }

        if (isMobile) {
            let Can_Width, Can_Height;
            if (window.innerHeight > window.innerWidth) {
                this.props.setApplicationLayoutMode("Portrait");
                Can_Width = this.props.constant.configGame.portraitCanvasWidth;
                Can_Height = this.props.constant.configGame.portraitCanvasHeight;
            } else {
                this.props.setApplicationLayoutMode("Landscape");
                Can_Width = this.props.constant.configGame.landscapeCanvasWidth;
                Can_Height = this.props.constant.configGame.landscapeCanvasHeight;
            }
            UIManager.getRef("mainPageOuterContainer").scale.x = (width * dpr) / Can_Width;
            UIManager.getRef("mainPageOuterContainer").scale.y = (height * dpr) / Can_Height;
            this.props.app.renderer.resize(viewportWidth / dpr * (width * dpr) / Can_Width, viewportHeight / dpr * (height * dpr) / Can_Height);
        }

        this.props.app.view.style.width = width + "px";
        this.props.app.view.style.height = height + "px";
        this.props.setApplicationResizeState(viewportWidth, viewportHeight, scaleX, scaleY);
        if (this.props.constant.configGame.centered === true) {
            this.props.app.view.style.position = "fixed";
            if (viewHeight > height) {
                this.props.app.view.style.top = (viewHeight / 2 - height / 2) + "px";
            } else {
                this.props.app.view.style.top = 0 + "px";
            }
            if (viewWidth > width) {
                this.props.app.view.style.left = (viewWidth / 2 - width / 2) + "px";
            } else {
                this.props.app.view.style.left = 0 + "px";
            }
        }


    }


    calculateCanvas() {
        if (this.iniFrame()) {
            this.handleResizeChange();
        } else {
            this.handleResizeChangeInIframe();
        }

    }
    //
    // shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
    //     if(nextProps.startRendering && nextProps.startRendering!= this.props.startRendering){}
    //        return true;
    // }

    justCalculate() {

        if (isMobile) {
            let Can_Width, Can_Height;
            if (window.innerHeight > window.innerWidth) {
                this.props.setApplicationLayoutMode("Portrait");
                Can_Width = this.props.constant.configGame.portraitCanvasWidth;
                Can_Height = this.props.constant.configGame.portraitCanvasHeight;
            } else {
                this.props.setApplicationLayoutMode("Landscape");
                Can_Width = this.props.constant.configGame.landscapeCanvasWidth;
                Can_Height = this.props.constant.configGame.landscapeCanvasHeight;
            }

            UIManager.getRef("mainPageOuterContainer").scale.x = (document.documentElement.clientHeight * window.devicePixelRatio) / Can_Width
            UIManager.getRef("mainPageOuterContainer").scale.y = (document.documentElement.clientHeight * window.devicePixelRatio) / Can_Width
        } else {
            UIManager.getRef("mainPageOuterContainer").scale.x = (document.documentElement.clientHeight * window.devicePixelRatio) / 1920
            UIManager.getRef("mainPageOuterContainer").scale.y = (document.documentElement.clientHeight * window.devicePixelRatio) / 1920
        }

    }

    render() {
        //https://webglfundamentals.org/webgl/lessons/webgl-resizing-the-canvas.html
        const {
            isGameLoaded, resizing, width, height, GameType
        } = this.state;

        let PROPS_TO_SEND_AutoplayInCanvas = {

            app: this.app,
            langObj: this.props.langObj,
            configGame: this.props.configGame,
            InCanvas: this.props.configGame.AUTOPLAY_UI_IN_CANVAS
        }

        let PROPS_TO_SEND_intro = {

            app: this.app,
            langObj: this.props.langObj,
            configGame: this.props.configGame,
            bannerType: "Intro"
        }
        let PROPS_TO_SEND_outro = {

            app: this.app,
            langObj: this.props.langObj,
            configGame: this.props.configGame,
            bannerType: "Outro"
        }
        let PROPS_TO_SEND_Commongame = {

            app: this.app,
            langObj: this.props.langObj,
            configGame: this.props.configGame,
        }
        let PROPS_TO_SEND_Menu = {
            width: this.props.width,
            height: this.props.height,
            langcode: this.props.langcode,
            app: this.app,
            lanAssetConfig: this.props.lanAssetConfig,
            langObj: this.props.langObj,
            constant: this.props.constant,
            onloadingComplete: this.onLoadComplete,
            configGame: this.props.configGame,
            LOADERUI: this.props.LOADERUI,
          
        }
        return (
            <UIManager type={"Container"} name={"mainPageOuterContainer"} id={"mainPageOuterContainer"} app={this.app}
                configGame={this.props.configGame}>
                <UIManager type={"Container"} id={"backgroundContainer"} app={this.app} name={"backgroundContainer"}
                    configGame={this.props.configGame}>

                </UIManager>

                <UIManager id={"mainPageContainer"} name={"mainPageContainer"} type={"Container"}
                    configGame={this.props.configGame}
                    ref={i => this.mainPageContainer = i} app={this.app}>


                    {!isGameLoaded &&
                        <Loader  {...PROPS_TO_SEND_Menu} />}
                    {isGameLoaded && this.props.startRendering &&
                        <Commongame {...PROPS_TO_SEND_Commongame} />}
                    {isGameLoaded && this.props.basegamestate && this.props.startRendering &&
                        <Basegame {...PROPS_TO_SEND_Commongame} />}
                    {isGameLoaded && this.props.startRendering && !this.props.basegamestate && this.props.featureType == "FREEGAME" &&
                        <Freegame {...PROPS_TO_SEND_Commongame} />}

                    {isGameLoaded && this.props.startRendering && !this.props.basegamestate && this.props.featureType == "BONUS" &&
                        <Bonus {...PROPS_TO_SEND_Commongame} />}
                    {isGameLoaded && this.props.startRendering && !this.props.showPaytable &&
                        <ButtonPanel {...PROPS_TO_SEND_Commongame} />}

                    {isGameLoaded && this.props.startRendering && !this.props.showPaytable &&
                        <PlayerMessage {...PROPS_TO_SEND_Commongame} />}

                    {isGameLoaded && this.props.startRendering && !this.props.showPaytable &&
                        <AutoplayInCanvas {...PROPS_TO_SEND_AutoplayInCanvas} />}

                    {isGameLoaded && this.props.startRendering && !this.props.showPaytable &&
                        <MenuInCanvas {...PROPS_TO_SEND_AutoplayInCanvas} />}

                    {isGameLoaded && this.props.startRendering &&
                        <FlowManager {...PROPS_TO_SEND_Commongame} />}

                    {isGameLoaded && this.props.startRendering && !this.props.showPaytable &&
                        <Overlay {...PROPS_TO_SEND_Commongame} />}

                    {
                        isGameLoaded && this.props.startRendering && this.props.featureJustFinished &&
                        <Banner {...PROPS_TO_SEND_outro}></Banner>
                    }
                    {
                        isGameLoaded && this.props.startRendering && this.props.featureJustTriggered &&
                        <Banner {...PROPS_TO_SEND_intro}></Banner>
                    }
                    {isGameLoaded && this.props.startRendering && <GAMESounds {...PROPS_TO_SEND_Commongame}></GAMESounds>}
                    {<Sounds {...PROPS_TO_SEND_Commongame}></Sounds>}

                    {isGameLoaded && this.props.startRendering && <SymbolTray {...PROPS_TO_SEND_Commongame}></SymbolTray>}
                </UIManager>
            </UIManager>)

    }
}

export default withPixiApp(connect(
    (state: Pick<IStore, 'asyncInitAction' | 'applicationState' | 'basegameState' | 'freegameState' | 'paytableState'>): IStateToProps =>
    ({
        showPaytable: state.paytableState.showPaytable,
        layoutMode: state.applicationState.layoutMode,
        // buttonPanelVisibility: state.applicationState.buttonPanelVisibility,
        featureJustFinished: state.freegameState.featureJustFinished,
        featureJustTriggered: state.basegameState.featureJustTriggered,
        basegamestate: state.basegameState.basegamestate,
        featureType: state.basegameState.featureType,
        startRendering: state.asyncInitAction.startRendering,


    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutMode: (layout: string): any => dispatch(applicationActions.setApplicationLayoutMode(layout)),
        setApplicationLoading: (isLoading: boolean): any => dispatch(applicationActions.setApplicationLoading(isLoading)),
        setApplicationResizeState: (resizewidth: number, resizeheight: number, scalex: number, scaley: number): any => dispatch(applicationActions.setApplicationResizeState(resizewidth,
            resizeheight,
            scalex,
            scaley))
    }))(MAINPAGE));